import { getRelatedProductsById } from "@/core/lib/api/main/main-shop-product";
import { getSettings } from "@/core/lib/api/main/setting";
import SwiperRelatedProducts from "./SwiperRelatedProducts";

type RelatedProductsProps = {
  productId: number;
};

export default async function RelatedProducts({
  productId,
}: RelatedProductsProps) {
  const [relatedProduct, settings] = await Promise.all([
    getRelatedProductsById(productId),
    getSettings(),
  ]);
  if (relatedProduct.related_products.length === 0) return null;


  return (
    <div className="w-full">
      <SwiperRelatedProducts items={relatedProduct.related_products} settings={settings} />
    </div>
  );
}
